<template>
  <v-container>
    <h1>Permisos Administrador</h1>
    <v-row class="ma-0">
      <v-spacer></v-spacer>
      <v-col class="pa-0 mb-4" style="display: flex; justify-content: flex-end;">
        <v-btn
          color="black"
          @click="dialogAssignPermissions = true"
          elevation="8" 
          class="white--text my-2"
          style="border-radius: 36px; border: 2px solid black; font-family: 'montserrat-semibold'; text-transform: none;"
          :disabled="!permissionList.includes('assignPermissions')"
        >
          {{ "Asignar permisos" }}
        </v-btn>
      </v-col>
    </v-row>
    <v-skeleton-loader type="table" v-if="isLoading" />
    <v-data-table class="d-none d-sm-block" v-else :items-per-page="10" hide-default-header :items="permissions" style="background-color: white !important">
      <template v-slot:header="{ props }">
        <thead style="background-color: #f9fafd;">
          <tr>
            <th class="header__title left">{{ "Admin" }}</th>
            <th class="header__title center">{{ 'N° de permisos' }}</th>
            <th class="header__title right">{{ 'Acciones' }}</th> 
          </tr>
        </thead>
      </template>
      <template v-slot:body="{ items }">
        <tbody style="background: #f9fafd;">
          <tr v-for="item in items" :key="item.id">
            <td class="table__item">{{ item.sEmail  }}</td>
            <td class="table__item">{{ item.permissions.length }}</td>
            <td class="table__item">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn @click="openDetail(item)" v-bind="attrs" v-on="on" icon color="black">
                    <v-icon>mdi-pencil-outline</v-icon>
                  </v-btn>
                </template>
                <span>Edit</span>
              </v-tooltip>
            </td>
          </tr>
        </tbody>
      </template>
    </v-data-table>
    <v-dialog v-model="dialogAssignPermissions" v-if="dialogAssignPermissions" max-width="600px" persistent>
      <v-card>
        <v-container class="mt-1" style="max-width: 600px">
          <!-- Título -->
          <v-card-title
            class="pa-0"
            style="display: flex; text-align: center; justify-content: center;"
          >
            <span class="title font-weight-bold text-textblack">
              {{ "Asignación de permisos" }}
            </span>
          </v-card-title>

          <!-- Subtítulo -->
          <v-card-subtitle
            class="mt-2 pb-0"
            style="text-align: center;"
          >
            {{ "Selecciona los permisos que deseas asignar a esta empresa." }}
          </v-card-subtitle>

          <!-- Checkboxes -->
          <v-card-text class="py-6 px-4">
            <v-autocomplete
              label="Selecciona un administrador"
              :items="admins"
              hide-details
              style="font-family: 'montserrat-medium'; border-radius: 20px;"
              outlined
              clearable
              class="mr-2 mb-4"
              item-value="sAdministratorId"
              item-text="administratorName"
              @change="getPermissions()"
              v-model="selectedAdmin"
            ></v-autocomplete>
            <v-row>
              <!-- Render dinámico en 2 columnas -->
              <v-col cols="12" sm="6">
                <div v-for="(perm, idx) in leftColumn" :key="perm.key">
                  <v-checkbox
                    color="black"
                    hide-details
                    :disabled="loadingAdmin"
                    v-model="permissionsModel[perm.key]"
                    :label="perm.label"
                  />
                </div>
              </v-col>
              <v-col cols="12" sm="6">
                <div v-for="perm in rightColumn" :key="perm.key">
                  <v-checkbox
                    color="black"
                    hide-details
                    :disabled="loadingAdmin"
                    v-model="permissionsModel[perm.key]"
                    :label="perm.label"
                  />
                </div>
              </v-col>
            </v-row>
          </v-card-text>

          <!-- Botones -->
          <v-card-actions class="mt-5" style="justify-content: space-evenly">
            <v-btn
              elevation="4"
              class="mr-2 px-10"
              style="
                color: black;
                border-radius: 36px;
                border: 2px solid black;
                background-color: #fff;
                font-family: 'montserrat-semibold';
                text-transform: none;
              "
              outlined
              @click="dialogAssignPermissions = false, selectedAdmin = null, permissionsModel = {}"
            >
              {{ "Cancelar" }}
            </v-btn>

            <v-btn
              color="black"
              elevation="4"
              class="white--text px-10"
              :disabled="!selectedAdmin || loadingAdmin"
              @click="assignPermissions()"
              style="
                border-radius: 36px;
                font-family: 'montserrat-semibold';
                text-transform: none;
              "
            >
              {{ "Asignar permisos" }}
            </v-btn>
          </v-card-actions>
        </v-container>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
  import moment from "moment";
  export default {
    name: "Modulos",
    props: {
      activeTab: String,
      permissionList: Array,
      enterprise: Object
    },
    data() {
      return {
        permissions: [],
        isLoading: false,
        loadingAdmin: false,
        dialogRequestPayment: false,
        forward: null,
        dialogAssignPermissions: false,
        admins: [],
        selectedAdmin: null,
        selectedPermissions: [],
        permissionsCatalogLocal: [
          { key: 'read',label: 'Obtener empresa' },
          { key: 'convertInvoices', label: 'Convertir facturas' },
          { key: 'createAlert', label: 'Crear alertas' },
          { key: 'createPayment', label: 'Crear pagos' },
          { key: 'createBeneficiary', label: 'Crear beneficiarios' },
          { key: 'createInvoice', label: 'Crear facturas' },
          { key: 'payInvoices', label: 'Pagar facturas' },
          { key: 'requestPayment', label: 'Cobrar Forward' },
          { key: 'deleteBeneficiary', label: 'Eliminar beneficiarios' },
          { key: 'updateInvoice', label: 'Actualizar facturas' },
          { key: 'createUser', label: 'Crear usuario' },
          { key: 'assignPermissions', label: 'Asignar permisos' },
          { key: 'assignModules', label: 'Asignar módulos' },
          { key: 'updateConversion', label: 'Actualizar conversion' },
        ],
        permissionsModel: {},
      };
    },
    watch: {
      activeTab(val) {
        if (val === 'permissions') {
          this.getModules();
          this.getAdmins();
        }
      }
    },
    computed: {
      fullCatalog() {
        return this.permissionsCatalogLocal;
      },
      leftColumn() {
        const mid = Math.ceil(this.fullCatalog.length / 2);
        return this.fullCatalog.slice(0, mid);
      },
      rightColumn() {
        const mid = Math.ceil(this.fullCatalog.length / 2);
        return this.fullCatalog.slice(mid);
      },
    },
    mounted() {
      if (this.activeTab === 'permissions') {
        this.getModules();
        this.getAdmins();
      }
    },
    methods: {
      getModules() {
        this.isLoading = true;
        this.permissions = [];
        const payload = {
          sEnterpriseId: this.$route.params.sEnterpriseId,
        };

        DB.post(`${URI}/api/v1/en/administrator/adminPermissions`, payload, {
          headers: {
            Authorization: this.$store.state.sToken
              ? `Bearer ${this.$store.state.sToken}`
              : ""
          }
        })
        .then((response) => {
          this.permissions = response.data.data;
          this.isLoading = false;
        }).catch((error) => {
          if (error.response.data.code) {
            this.$router.push("/welcome").catch(() => {});
          }
          this.mixError(error.response.data.message, error.response.status);
        });
      },
      getAdmins() {
        this.isLoading = true;
        this.admins = [];

        DB.get(`${URI}/api/v1/en/administrator/admins`, {
          headers: {
            Authorization: this.$store.state.sToken
              ? `Bearer ${this.$store.state.sToken}`
              : ""
          }
        })
        .then((response) => {
          this.admins = response.data.admins;
          this.isLoading = false;
        }).catch((error) => {
          if (error.response.data.code) {
            this.$router.push("/welcome").catch(() => {});
          }
          this.mixError(error.response.data.message, error.response.status);
        });
      },
      formatMoney(value) {
        let multiplied = value * 100;
        let rounded = Math.round(multiplied);
        let formattedNumber = rounded / 100;
        // Si el valor es -0, lo convertimos a 0
        if (Object.is(formattedNumber, -0)) {
          formattedNumber = 0;
        }
        return new Intl.NumberFormat("en-US", {
          style: "decimal",
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }).format(formattedNumber);
      },
      formatDate: function (date) {
        if (this.selectLanguage === "sp") {
          moment.locale("es");
        } else {
          moment.locale("en");
        }
        let newDate = moment(date);
        let formattedDate = newDate.format("MMMM DD, YYYY HH:mm a");
        return formattedDate;
      },
      getPermissions() {
        this.loadingAdmin = true;
        this.permissionsModel = {};
        const payload = {
          sEnterpriseId: this.$route.params.sEnterpriseId,
          sAdministratorId: this.selectedAdmin,
        };

        DB.post(`${URI}/api/v1/en/administrator/adminPermissions`, payload, {
          headers: {
            Authorization: this.$store.state.sToken
              ? `Bearer ${this.$store.state.sToken}`
              : ""
          }
        })
        .then((response) => {
          this.selectedPermissions = response.data.data[0]?.permissions || [];
          this.permissionsModel = this.fullCatalog.reduce((acc, p) => {
            acc[p.key] = false;
            return acc;
          }, {});

          const assignedSet = new Set(
            (this.selectedPermissions || []).map(p => p.sPermission)
          );

          Object.keys(this.permissionsModel).forEach(k => {
            if (assignedSet.has(k)) this.permissionsModel[k] = true;
          });
          this.loadingAdmin = false;
        }).catch((error) => {
          this.mixError(error.response.data.message, error.response.status);
        });
      },
      openDetail(item) {
        this.dialogAssignPermissions = true;
        this.selectedAdmin = item.sAdministratorId;
        this.getPermissions();
      },
      assignPermissions() {
        this.loadingAdmin = true;
        const selectedPerms = Object.keys(this.permissionsModel).filter(k => this.permissionsModel[k]);
        const payload = {
          sEnterpriseId: this.$route.params.sEnterpriseId,
          sAdministratorId: this.selectedAdmin,
          permissions: selectedPerms
        };

        DB.post(`${URI}/api/v1/en/administrator/assignPermissions`, payload, {
          headers: {
            Authorization: this.$store.state.sToken
              ? `Bearer ${this.$store.state.sToken}`
              : ""
          }
        })
        .then(() => {
          this.dialogAssignPermissions = false;
          this.selectedAdmin = null;
          this.permissionsModel = {};
          this.loadingAdmin = false;
          this.$emit('wallets:update');
          this.getModules();
        }).catch((error) => {
          this.loadingAdmin = false;
          this.mixError(error.response.data.message, error.response.status);
        });
      },
    }
  };
</script>
<style scoped>
</style>